import { TOUR } from "../constants/testIds";
import { TourCard } from "./TourCard";
import { Info, Loader2 } from "lucide-react";

export const TourResults = ({ tours, loading, onSelect }) => {
  if (loading) {
    return (
      <div
        data-testid={TOUR.loadingState}
        className="mt-10 rounded-3xl bg-white border border-[#F0DFC1] p-12 text-center shadow-sm"
      >
        <Loader2 className="w-10 h-10 text-teal animate-spin mx-auto mb-4" />
        <div className="font-display text-2xl text-[#063B4E]">
          Ищем лучшие варианты...
        </div>
        <div className="text-sm text-[#4A5A6B] mt-2">
          Сравниваем сотни предложений и подбираем самые интересные
        </div>
      </div>
    );
  }

  if (!tours || tours.length === 0) return null;

  return (
    <div data-testid={TOUR.resultsSection} className="mt-10">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-coral font-semibold">
            Найдено предложений
          </div>
          <div className="font-display text-3xl sm:text-4xl text-[#063B4E]" data-testid={TOUR.resultsCount}>
            {tours.length}{" "}
            <span className="text-[#4A5A6B] text-base font-sans">вариантов под вас</span>
          </div>
        </div>
        <div
          data-testid={TOUR.disclaimer}
          className="inline-flex items-start gap-2 rounded-xl bg-[#FFF7EC] border border-[#F0DFC1] px-4 py-3 text-xs text-[#4A5A6B] max-w-md"
        >
          <Info className="w-4 h-4 text-coral shrink-0 mt-0.5" />
          <span>
            <strong className="text-[#063B4E]">Предварительное предложение.</strong>{" "}
            Стоимость и наличие уточняются менеджером.
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {tours.map((t) => (
          <TourCard key={t.id} tour={t} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};
